import React, { Component } from 'react';
import PropTypes from "prop-types";
import catchLifeCycleErrors from 'utils/catchLifeCycleErrors';
import { metaDescription } from 'utils/seoUtils';

import {StandardPage} from "../../Common/pages/StandardPage";
import {RightColumn} from "../../Common/pages/RightColumn";

@catchLifeCycleErrors
export default class GreyhoundRacingFastResultsPage extends Component {
  static propTypes = {
    GreyhoundRacingFastResults: PropTypes.element.isRequired,
    location: PropTypes.object.isRequired,
  };

  render() {
    const {
      location,
      GreyhoundRacingFastResults,
    } = this.props;

    const metaDescriptionValue = "The latest Greyhound results as they happen from Sporting Life's Fast Results service";

    return (
      <div className="GreyhoundRacingResults">
        <StandardPage sport="greyhounds" title="Fast Results" helmetProps={{...metaDescription(metaDescriptionValue)}}>
          <div className="main-layout-left-column">
            {GreyhoundRacingFastResults}
          </div>

          <RightColumn location={location}
                       sport="greyhounds"
                       content={
                         ["topMpu", "ocWidget", "racingTips", "bottomMpu", "horseRacingNextRaceOff", "footballTips"]} />
        </StandardPage>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/GreyhoundRacing/containers/GreyhoundRacingFastResultsPage.js